import { TOGGLE_MODAL } from '../actions/types'

export const toggleModal = ( modalProps = null ) => dispatch => {

  dispatch({ type: TOGGLE_MODAL, payload: modalProps });

}
